// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"83f428b7","453":"8e648a77","667":"8eb531f3"}[chunkId] + ".chunk.js";
};